import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://www.zocmedical.com";
const SUFFIX = "ZOC Medical";

// Build a BreadcrumbList JSON-LD from an array of {name, path}
export const buildBreadcrumbs = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((it, i) => ({
    "@type": "ListItem",
    "position": i + 1,
    "name": it.name,
    "item": `${SITE_URL}${it.path}`,
  })),
});

export const Seo = ({
  title,
  description,
  path = "/",
  keywords,
  jsonLd,
  breadcrumbs,
  image,
  noindex = false,
}) => {
  const fullTitle = title ? `${title} | ${SUFFIX}` : `${SUFFIX} — Care Management Platform & Services`;
  const url = `${SITE_URL}${path}`;
  const ogImage = image || `${SITE_URL}/zoc-mark.png`;
  const bcJsonLd = breadcrumbs?.length ? buildBreadcrumbs(breadcrumbs) : null;

  return (
    <Helmet>
      <html lang="en" />
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="ZOC Medical" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content="ZOC Medical — Care Management Platform & Services" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
      {bcJsonLd && <script type="application/ld+json">{JSON.stringify(bcJsonLd)}</script>}
    </Helmet>
  );
};
